import { NewIconProps } from '@diritto/common/style/icon';

export interface ArrowNewIconProps extends NewIconProps {
  className?: string;
  color?: string;
  direction?: 'left' | 'right' | 'up' | 'down';
}

const getRotate = (direction: 'left' | 'right' | 'up' | 'down') => {
  let rotate = 0;

  if (direction === 'left') {
    rotate = 90;
  } else if (direction === 'up') {
    rotate = 180;
  } else if (direction === 'right') {
    rotate = 270;
  }
  return rotate;
};
export const ArrowRoundIcon = ({ className, direction = 'down' }: ArrowNewIconProps) => (
  <svg
    className={className}
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ transform: `rotate(${getRotate(direction)}deg)` }}>
    <circle cx="9" cy="9" r="9" fill="white" />
    <circle cx="9" cy="9" r="8.5" stroke="black" strokeOpacity="0.08" />
    <g clipPath="url(#clip0_20960_83880)">
      <path
        d="M5.5 8.08628L9.00213 11.5L12.5 8.08628L11.8985 7.5L9.00213 10.3233L6.10146 7.5L5.5 8.08628Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_20960_83880">
        <rect width="8" height="12" fill="white" transform="translate(3 13.5) rotate(-90)" />
      </clipPath>
    </defs>
  </svg>
);
